
export default function TeamSection() {
  const leadership = [
    {
      name: '张明华',
      position: '董事长兼总经理',
      description: '茶叶行业从业20年，云南大学农学院毕业，致力于传统茶文化与现代商业的完美结合。',
      experience: '20年茶叶行业经验',
      specialty: '企业战略规划',
      image: 'https://public.readdy.ai/ai/img_res/770fafc2728856b9afb416f124e27061.jpg'
    },
    {
      name: '李慧敏',
      position: '技术总监',
      description: '茶叶加工技术专家，拥有多项茶叶加工技术专利，主导公司技术创新和工艺改进。',
      experience: '15年技术研发经验',
      specialty: '茶叶加工技术',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20technical%20director%20in%20business%20attire%2C%20experienced%20tea%20processing%20expert%2C%20confident%20woman%20leader%20in%20manufacturing%20environment%2C%20technical%20specialist%20portrait&width=300&height=400&seq=team-02&orientation=portrait'
    },
    {
      name: '王国强',
      position: '市场总监',
      description: '市场营销专家，具有丰富的品牌推广和渠道建设经验，负责公司品牌建设和市场开拓。',
      experience: '12年市场营销经验',
      specialty: '品牌推广与渠道建设',
      image: 'https://readdy.ai/api/search-image?query=Professional%20marketing%20director%20in%20business%20suit%2C%20confident%20male%20executive%20with%20sales%20background%2C%20experienced%20market%20development%20leader%2C%20corporate%20marketing%20specialist%20portrait&width=300&height=400&seq=team-03&orientation=portrait'
    },
    {
      name: '陈雅君',
      position: '质量总监',
      description: '食品安全专家，负责建立和完善公司质量管理体系，确保产品质量稳定可靠。',
      experience: '10年质量管理经验',
      specialty: '质量控制与食品安全',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20quality%20control%20director%2C%20experienced%20food%20safety%20expert%20in%20laboratory%20setting%2C%20confident%20quality%20assurance%20manager%2C%20technical%20quality%20specialist%20portrait&width=300&height=400&seq=team-04&orientation=portrait'
    }
  ];

  const departments = [
    {
      name: '研发部门',
      description: '负责新产品开发和工艺改进',
      members: 15,
      icon: 'ri-flask-line',
      color: 'from-blue-500 to-blue-600'
    },
    {
      name: '生产部门',
      description: '负责茶叶的加工生产',
      members: 80,
      icon: 'ri-settings-3-line',
      color: 'from-blue-400 to-blue-500'
    },
    {
      name: '质检部门',
      description: '负责产品质量检测和控制',
      members: 12,
      icon: 'ri-search-2-line',
      color: 'from-purple-500 to-purple-600'
    },
    {
      name: '销售部门',
      description: '负责市场推广和销售',
      members: 25,
      icon: 'ri-line-chart-line',
      color: 'from-orange-500 to-orange-600'
    },
    {
      name: '采购部门',
      description: '负责原料采购和供应链管理',
      members: 8,
      icon: 'ri-shopping-cart-line',
      color: 'from-teal-500 to-teal-600'
    },
    {
      name: '行政部门',
      description: '负责行政管理和人事工作',
      members: 18,
      icon: 'ri-team-line',
      color: 'from-indigo-500 to-indigo-600'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            团队介绍
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            我们拥有一支专业、敬业的团队，为公司的发展提供强有力的支撑
          </p>
        </div>

        {/* Leadership Team */}
        <div className="mb-16">
          <h3 className="text-xl md:text-2xl font-bold text-center text-gray-800 mb-8">核心团队</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {leadership.map((leader, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group hover:transform hover:scale-105"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={leader.image}
                    alt={leader.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h4 className="text-lg md:text-xl font-bold text-gray-800 mb-1">{leader.name}</h4>
                  <p className="text-blue-600 font-medium mb-3 text-sm md:text-base">{leader.position}</p>
                  <p className="text-gray-600 text-xs md:text-sm leading-relaxed mb-4">
                    {leader.description}
                  </p>
                  <div className="space-y-2">
                    <div className="flex items-center text-xs md:text-sm text-gray-500">
                      <i className="ri-time-line mr-2"></i>
                      {leader.experience}
                    </div>
                    <div className="flex items-center text-xs md:text-sm text-gray-500">
                      <i className="ri-star-line mr-2"></i>
                      {leader.specialty}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Departments */}
        <div className="mb-16">
          <h3 className="text-xl md:text-2xl font-bold text-center text-gray-800 mb-8">部门结构</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {departments.map((dept, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 group hover:transform hover:scale-105"
              >
                <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${dept.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${dept.icon} text-white text-2xl`}></i>
                </div>
                
                <h4 className="text-lg md:text-xl font-bold text-gray-800 mb-2">{dept.name}</h4>
                <p className="text-gray-600 mb-4 text-sm md:text-base">{dept.description}</p>
                
                <div className="flex items-center text-emerald-600 font-medium text-sm md:text-base">
                  <i className="ri-user-line mr-2"></i>
                  {dept.members} 人
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Team Culture */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white">
          <div className="text-center mb-8">
            <h3 className="text-xl md:text-2xl font-bold mb-4">团队文化</h3>
            <p className="text-blue-100 max-w-3xl mx-auto text-sm md:text-base">
              我们建立了积极向上的企业文化，鼓励创新、协作和持续学习
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-amber-500 rounded-full flex items-center justify-center">
                <i className="ri-lightbulb-line text-white text-xl"></i>
              </div>
              <h4 className="font-bold mb-2 text-sm md:text-base">创新驱动</h4>
              <p className="text-blue-100 text-xs md:text-sm">鼓励员工提出创新想法，推动技术和管理创新</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-amber-500 rounded-full flex items-center justify-center">
                <i className="ri-team-line text-white text-xl"></i>
              </div>
              <h4 className="font-bold mb-2 text-sm md:text-base">团队协作</h4>
              <p className="text-blue-100 text-xs md:text-sm">强调团队合作精神，共同完成挑战性目标</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-amber-500 rounded-full flex items-center justify-center">
                <i className="ri-book-open-line text-white text-xl"></i>
              </div>
              <h4 className="font-bold mb-2 text-sm md:text-base">持续学习</h4>
              <p className="text-blue-100 text-xs md:text-sm">提供培训机会，支持员工职业发展和能力提升</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-amber-500 rounded-full flex items-center justify-center">
                <i className="ri-heart-line text-white text-xl"></i>
              </div>
              <h4 className="font-bold mb-2 text-sm md:text-base">关爱员工</h4>
              <p className="text-blue-100 text-xs md:text-sm">关注员工身心健康，提供良好的工作环境</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
